var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStepsIconActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.75C0 0.783503 0.783501 0 1.75 0H14.25C15.2165 0 16 0.783502 16 1.75V11.8357C15.5875 11.3259 14.9568 11 14.25 11C13.0074 11 12 12.0074 12 13.25V14H11.25C10.0074 14 9 15.0074 9 16.25C9 17.4926 10.0074 18.5 11.25 18.5H12V19.25C12 19.513 12.0451 19.7654 12.128 20H1.75C0.783501 20 0 19.2165 0 18.25V1.75ZM4 4.75C4 4.33579 4.33579 4 4.75 4H11.25C11.6642 4 12 4.33579 12 4.75C12 5.16421 11.6642 5.5 11.25 5.5H4.75C4.33579 5.5 4 5.16421 4 4.75ZM4 8.75C4 8.33579 4.33579 8 4.75 8H7.25C7.66421 8 8 8.33579 8 8.75C8 9.16421 7.66421 9.5 7.25 9.5H4.75C4.33579 9.5 4 9.16421 4 8.75Z",
    fill: "#171717",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13.25C15 12.8358 14.6642 12.5 14.25 12.5C13.8358 12.5 13.5 12.8358 13.5 13.25V15.5H11.25C10.8358 15.5 10.5 15.8358 10.5 16.25C10.5 16.6642 10.8358 17 11.25 17H13.5V19.25C13.5 19.6642 13.8358 20 14.25 20C14.6642 20 15 19.6642 15 19.25V17H17.25C17.6642 17 18 16.6642 18 16.25C18 15.8358 17.6642 15.5 17.25 15.5H15V13.25Z",
    fill: "#171717",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepsIconActive);
export default __webpack_public_path__ + "static/media/steps-icon-active.41ebe7ddd070a13c76d5f51378a6358f.svg";
export { ForwardRef as ReactComponent };